import { keyframes } from '@emotion/react';
import styled from '@emotion/styled';

type Props = {
  color?: string;
};

const loadingDotsAnimation = keyframes`
  0% { opacity: 0.1; }
  20% { opacity: 0.5; }
  40% { opacity: 0.9; }
  50% { opacity: 1; }
  60% { opacity: 0.9; }
  80% { opacity: 0.5; }
  100% { opacity: 0.1; }
`;

const LoadingDots = styled.div`
  display: flex;
  align-items: center;
  color: ${({ color }) => color};

  & > span {
    animation: ${loadingDotsAnimation} 1.2s infinite;
    margin-right: 1px;
  }
`;

export function ThreeDots({ color = 'grey' }: Props) {
  return (
    <LoadingDots color={color}>
      <span>.</span>
      <span>.</span>
      <span>.</span>
    </LoadingDots>
  );
}
